// -------------------------------------------------------------------- constants --------------------------------------------------------------------

// *************************************************************** position *****************************************************************
const GET_POSITION_PERMISSION_TINY_SUCCESS = 'GET_POSITION_PERMISSION_TINY_SUCCESS';
const UPDATE_POSITION_PERMISSION_TINY_SUCCESS = 'UPDATE_POSITION_PERMISSION_TINY_SUCCESS';


// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// *************************************************************** position *****************************************************************

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _getPermissionSuccess(payload) {
  return {
    type: GET_POSITION_PERMISSION_TINY_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _setPermissionSuccess(payload) {
  return {
    type: UPDATE_POSITION_PERMISSION_TINY_SUCCESS,
    payload: payload.data,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

// *************************************************************** position *****************************************************************

/**
 *
 * @param {Number} position
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function getPermission(position, params = {}, callback = () => {
}) {
  return (dispatch, gs, api) => {
    if (app.can('PositionPermissions@index')) {

      api.get(`/position/${position}/permissions`, {params})
        .then((res) => {
          dispatch(_getPermissionSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          callback(err);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          'routes.permission error',
          {
            permission: `${app.translate('routes.home.basic.permission.PositionPermissions', 'PositionPermissions')} - ${app.translate('routes.home.basic.permission.index', 'index')}`,
          },
          'permission error',
        ), 'error');
    }
  };
}

/**
 *
 * @param {Number} position
 * @param {Object} data
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function setPermission(position, data, params = {}, callback = () => {
}) {
  return (dispatch, gs, api) => {
    if (app.can('PositionPermissions@update')) {
      let loader = app.loading(app.translate('routes.home.basic.permission.Assigning Permissions'));

      api.put(`/position/${position}/permissions`, {
        data: {positionPermission: data}, params,
      })
        .then((res) => {
          dispatch(_setPermissionSuccess(res));
          loader.hide(() => app.message(app.translate('routes.home.basic.permission.Permissions Assigned Successfully')));
          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide(() => app.error(
            err, 'routes.home.basic.permission.', 'عملیات بروزرسانی با شکست مواجه شد',
            app.translate('routes.home.basic.permission.Permissions Assignment Failed'),
          ));
          callback(err);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          'routes.permission error',
          {
            permission: `${app.translate('routes.home.basic.permission.PositionPermissions', 'PositionPermissions')} - ${app.translate('routes.home.basic.permission.update', 'update')}`,
          },
          'permission error',
        ), 'error');
    }
  };
}

export function emptyPermission() {
  return _getPermissionSuccess({data: []});
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {Object} state
 * @param {{type: String, payload: Object}} action
 * @return {Object}
 */
export default function reducer(state = {
  permissionsPosition: [],
  meta: {},
}, action) {
  switch (action.type) {
    case GET_POSITION_PERMISSION_TINY_SUCCESS:
      return Object.assign({}, state, {
        permissionsPosition: action.payload.data && action.payload.data[0] && Array.isArray(action.payload.data[0]) ? action.payload.data[0] : action.payload.data,
      });
    default:
      return state;
  }
}
